export interface DrainTriggerScheduler {
	trigger: () => void;
}

export const DRAIN_TRIGGER_DEBOUNCE_MS = 500;

const createDrainTriggerScheduler = (
	post: () => void,
	debounceMs: number = DRAIN_TRIGGER_DEBOUNCE_MS
): DrainTriggerScheduler => {
	let timer: ReturnType<typeof setTimeout> | null = null;

	return {
		trigger: () => {
			if (timer) return;
			timer = setTimeout(() => {
				timer = null;
				post();
			}, debounceMs);
		}
	};
};

export default createDrainTriggerScheduler;
